import { HttpMethods, APIContexts } from 'enums';
import { apiRequestHandler, apiHost } from '.';

const apiContext = `${APIContexts.PLAYLIST}/`;

export const CreateChannelArchitectureAPI = ({
  requestBody,
  onSuccess,
  ...rest
}) => {
  const api = 'CreateChannelArchitectureTemplate';
  const endpoint = `${apiHost}${apiContext}${api}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    payload: requestBody,
    onSuccess: (res) => onSuccess(res[0]),
    ...rest,
  });
};

export const UpdateChannelArchitectureAPI = ({
  requestBody,
  onSuccess,
  ...rest
}) => {
  const api = 'EditChannelArchitectureTemplate';
  const endpoint = `${apiHost}${apiContext}${api}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    payload: requestBody,
    onSuccess: (res) => onSuccess(res[0]),
    ...rest,
  });
};

export const DeleteChannelArchitectureAPI = ({
  templateID,
  onSuccess,
  ...rest
}) => {
  const api = 'DeleteChannelArchitectureTemplate';
  const endpoint = `${apiHost}${apiContext}${api}/${templateID}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.DELETE,
    onSuccess: (res) => onSuccess(res[0]),
    ...rest,
  });
};

export const UpdatePlaylistAPI = ({ requestBody, onSuccess, ...rest }) => {
  const api = 'Playlist';
  const endpoint = `${apiHost}${apiContext}${api}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    payload: requestBody,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const RetimePlaylistAPI = ({ requestBody, onSuccess, ...rest }) => {
  const api = 'Retime';
  const endpoint = `${apiHost}${apiContext}${api}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    payload: requestBody,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetBrandingAPI = ({ queryParams, onSuccess, ...rest }) => {
  const api = 'Branding';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.channelId}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export function GetPlaylistAPI({ queryParams, onSuccess, ...rest }) {
  const parentIdParam = queryParams.parentId
    ? `&ParentId=${queryParams.parentId}`
    : '';
  const endpoint = `${apiHost}Playlist?ChannelId=${queryParams.channelId}&Day=${queryParams.date}&Page=${queryParams.page}${parentIdParam}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
}

export function GetPlaylistSettingsAPI({
  channelId,
  page,
  onSuccess,
  ...rest
}) {
  const endpoint = `${apiHost}${apiContext}settings/${channelId}?page=${encodeURIComponent(page)}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
}
